import React, { useState } from "react";

import { Button, Form, Card, Row, Col, Divider } from "antd";

import sitemapApi from "../api/sitemapApi";
import Swal from "sweetalert2";

const Sitemap = (props) => {
  const [loading, setLoading] = useState(false);

  const generateSitemap = (type) => {
    setLoading(true);

    const payload = {
      types: type,
    };

    sitemapApi
      .generateSitemap(payload)
      .then((res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Generate thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <>
      <Card title="Generate sitemap cho website"         className="criclebox tablespace mb-24"
>
        <div>
          <br />
          <Form
            labelCol={{
              span: 12,
            }}
            layout="horizontal"
            size="large"
          >
            <Row gutter={[24, 0]}>
              <Col span={12}>
                <Form.Item label="Sitemap toàn hệ thống">
                  <Button
                    size="small"
                    onClick={() => {
                      generateSitemap([
                        "product-category",
                        "blog-category",
                        "page",
                        "product",
                        "blog",
                      ]);
                    }}
                  >
                    Generate
                  </Button>
                </Form.Item>
                <Divider />
                <Form.Item label="Sitemap chuyên mục bài viết">
                  <Button
                    size="small"
                    onClick={() => {
                      generateSitemap(["blog-category"]);
                    }}
                  >
                    Generate
                  </Button>
                </Form.Item>{" "}
                <Divider />
                <Form.Item label="Sitemap chuyên mục sản phẩm">
                  <Button
                    size="small"
                    onClick={() => {
                      generateSitemap(["product-category"]);
                    }}
                  >
                    Generate
                  </Button>
                </Form.Item>{" "}
                <Divider />
                <Form.Item label="Sitemap trang động">
                  <Button
                    size="small"
                    onClick={() => {
                      generateSitemap(["page"]);
                    }}
                  >
                    Generate
                  </Button>
                </Form.Item>{" "}
                <Divider />
                <Form.Item label="Sitemap sản phẩm">
                  <Button
                    size="small"
                    onClick={() => {
                      generateSitemap(["product"]);
                    }}
                  >
                    Generate
                  </Button>
                </Form.Item>{" "}
                <Divider />
                <Form.Item label="Sitemap bài viết">
                  <Button
                    size="small"
                    onClick={() => {
                      generateSitemap(["blog"]);
                    }}
                  >
                    Generate
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Card>
    </>
  );
};

export default Sitemap;
